import { getStates } from "../../api/SelectApi";
import InputSelect from "../InputSelect";

import { tr } from "../../i18n";
const SelectState = ({ country_id, ...props }) => {
  const data = {
    name: props.name || "state_id",
    placeholder: tr("settings:select_state"),
    rules: props.rules,
    className: props.className,
    defaultValue: props.defaultValue,
  };

  async function handleData(search = "") {
    if (!country_id) return [];
    const result = await getStates(country_id, search);
    return result.data.map((d) => ({
      label: d.text,
      value: d.id,
    }));
  }

  return (
    <InputSelect
      key={country_id}
      props={props}
      data={data}
      handleOnLoadData={handleData}
    />
  );
};

export default SelectState;
